/* eslint-disable */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { fetchGuia, fetchGuiaConsulta, getPrestador, updatePrestador } from '@store/actions'
import AccordionGroup from '@components/accordion_group';
import AccordionChild from '@components/accordion_child';
import CustomSnackbar from '@components/shared/custom_snackbar'
import FormFiltro from '@components/reimpressao-guia/form_filtro';
import TableGuias from '@components/reimpressao-guia/table_guias';
import Layout from '@components/shared/layout';
import m from '@utils/strings';
import '@styles/reimpressao-guia.css';
import AjaxLoader from '@components/shared/ajax_loader';
import userManager from '@utils/userManager';

class ReimpressaoGuia extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeKey: '1',
            snackbarType: 'error',
            snackbarMsg: '',
            showLoader: false,
            showPrestadorLoader: false,
        }

        setTimeout(() => {
            this.applyFilter(null);
        }, 600);
    }

    verifiyIfUserIsAuthenticated = () => {
        const { user } = this.props
        if (!user || user.expired) {
            userManager.signinRedirect();
        }
    }

    getUpdatePrestador = () => {
        const { user } = this.props
        if (user != null && user.profile != null) {
            if (!this.isFetchingPrestador) {
                this.isFetchingPrestador = true;
                let cpfCnpj = user.profile.prestador instanceof Array ? user.profile.prestador[0] : user.profile.prestador
                this.props.getPrestador(cpfCnpj, (result) => {
                    this.props.updatePrestador(result);
                    this.setState({ showPrestadorLoader: false });
                });
            }
        }
    }

    componentDidUpdate() {
        this.verifiyIfUserIsAuthenticated();
    }

    componentDidMount() {
        if(_.isEmpty(this.props.prestador)) {
            this.setState({ showPrestadorLoader: true });
            this.getUpdatePrestador();
        }
        this.verifiyIfUserIsAuthenticated();
        document.addEventListener("keydown", this.handleKeyDown, false);
        this.focusFirstField();
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown, false);
    }

    handleKeyDown = (event) => {
        if (event.key == 'F7' && this.state.activeKey == '1') {
            this.setState({ activeKey: '' });
        }
        else if (event.key == 'F7') {
            this.focusFirstField();
            this.setState({ activeKey: '1' });
        }
    }

    handleAccordionSelect = (activeKey) => {
        if (this.state.activeKey === '1') {
            this.setState({ activeKey: '' });
        }
        else {
            this.focusFirstField();
            this.setState({ activeKey: '1' });
        }
    }

    callSnackbar = (snackbarMsg, snackbarType) => {
        this.setState({ snackbarMsg });
        this.setState({ snackbarType });
        this.click();
    }

    applyFilter = (params) => {
        if (_.isEmpty(this.props.prestador)) {
            setTimeout(() => {
                this.applyFilter(null);
            }, 600);
            return;
        }
        this.applyFilterTable(params)
    }

    getGuia = (senha, fileName) => {
        this.setState({ showLoader: true });
        this.props.fetchGuia(
            senha,
            this.successResultGuiasHandler,
            this.errorResultGuiasHandler
        )
    }

    getGuiaConsulta = (idCobranca) => {
        this.setState({ showLoader: true });
        this.props.fetchGuiaConsulta(
            idCobranca,
            this.successResultGuiasHandler,
            this.errorResultGuiasHandler
        )
    }

    successResultGuiasHandler = (result) => {
        const url = window.URL.createObjectURL(new Blob([result.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', `_blank`);
        //link.setAttribute('download', `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        this.setState({ showLoader: false });
    }

    errorResultGuiasHandler = (error) => {
        this.setState({
            showLoader: false,
            snackbarType: 'error',
            snackbarMsg: m.TELA_REIMPRESSAO_GUIA.NOTIFICACAO_ERRO_IMPRIMIR_GUIA
        });
        
        this.click();
    }

    render() {
        const { showLoader, showPrestadorLoader } = this.state;

        const loader = showLoader ? <AjaxLoader ajaxMessage={m.TELA_REIMPRESSAO_GUIA.MENSAGEM_AJAX_LOADER} /> : "";
        const prestadorLoader = showPrestadorLoader ? <AjaxLoader ajaxMessage={m.TELA_REIMPRESSAO_GUIA.MENSAGEM_LOADER_BUSCANDO_PRESTADOR} /> : "";

        return (
            <div>
                {loader}
                {prestadorLoader}
                <Layout
                    user={this.props.user}
                    iconePath={''}
                    content={m.TELA_REIMPRESSAO_GUIA.TITULO_PAGINA}
                />
                <div id='label-descricao'>
                    {m.TELA_REIMPRESSAO_GUIA.TEXTO_ACIMA_ACCORDION}
                </div>
                <AccordionGroup
                    withoutLateralMenu={true}
                    activeKey={this.state.activeKey}
                    onSelect={this.handleAccordionSelect}
                    childs={[
                        <AccordionChild
                            componentToRender={
                                <FormFiltro
                                    callSnackbar={this.callSnackbar}
                                    applyFilter={this.applyFilter}
                                    focusFirstField={e => this.focusFirstField = e}
                                    activeAccordion={this.state.activeKey}
                                />
                            }
                            title={m.TELA_REIMPRESSAO_GUIA.TITULO_ACCORDION}
                            keyboardCommandKey="F7"
                            keyAccordion="1"
                            key="1"
                        />
                    ]}
                />
                <TableGuias
                    updateTableRows={e => this.updateTableRows = e}
                    updateApplyingFilter={e => this.updateApplyingFilter = e}
                    applyFilterTable={e => this.applyFilterTable = e}
                    callSnackbar={this.callSnackbar}
                    getGuia={this.getGuia}
                    getGuiaConsulta={this.getGuiaConsulta}
                    prestador={this.props.prestador}
                />
                <CustomSnackbar
                    setClick={click => this.click = click}
                    variant={this.state.snackbarType}
                    duration={2500}
                    content={this.state.snackbarMsg}
                />
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        prestador: state.prestador,
    }
}

export default connect(mapStateToProps, { getPrestador, fetchGuiaConsulta, updatePrestador, fetchGuia })(ReimpressaoGuia);
